import { render } from "./SoupView.vue?vue&type=template&id=355b0aaf"
import script from "./SoupView.vue?vue&type=script&lang=js"
export * from "./SoupView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__